<!-- Hide workspace ng-container *ngIf="selectedView == 'details'" {{selectedWorkspace.name}}  [model]="breadcrumbItems"-->
<ng-container>    
    <div class="p-d-flex p-jc-between breadcrembBar">
        <p-breadcrumb ></p-breadcrumb>
        <h3 class="p-mt-2 p-mb-0"></h3>
        <p-menubar [model]="menuItems" styleClass="top-menu submenu-align-right">
            <ng-template pTemplate="start" style="width: 100%">
                <span class="p-input-icon-left" style="float: right; margin-left: 5px; position: relative">
                    <i class="pi pi-search searchPosition"></i>
                    <input type="text" style="float: right; margin: 2px 5px 0px 0px; padding-right: 30px" pInputText
                        placeholder="Search..." [formControl]="searchControl" />
    
                    <!-- <button *ngIf="searchWorkbookControl.value" type="button" pButton icon="pi pi-times"
                        class="p-button-text p-button-secondary clear-search-btn" (click)="clearWorkbookSearch()"
                        style="
                        position: absolute;
                        right: 5px;
                        top: 50%;
                        transform: translateY(-50%);
                    "></button> -->
                </span>
            </ng-template>
        </p-menubar>
    </div>
    
    <p-tabView #tabView (onChange)="handleChange($event)" class="no-padding">
        <p-tabPanel header="All Tasks">
            <app-task-table *ngIf="app.filterMode=='all'" [filterValue]="'AllTasks'" [cols]="cols" [searchValue]="searchValue" [filterInColumns]="filterInColumns" [isHideSide]="isHideSide" [selectedGroupByValue]="selectedGroupByValue" (onSelectTask)="onSelectTask($event)">
            </app-task-table>
        </p-tabPanel>
        <p-tabPanel header="By Me">
            <app-task-table *ngIf="app.filterMode=='by-me'" [filterValue]="'ByMe'" [cols]="cols" [searchValue]="searchValue" [filterInColumns]="filterInColumns" [isHideSide]="isHideSide" [selectedGroupByValue]="selectedGroupByValue" (onSelectTask)="onSelectTask($event)">
            </app-task-table>
        </p-tabPanel>
        <p-tabPanel header="For Me">
            <app-task-table *ngIf="app.filterMode=='for-me'" [filterValue]="'ForMe'" [searchValue]="searchValue" [filterInColumns]="filterInColumns" [cols]="cols" [isHideSide]="isHideSide" [selectedGroupByValue]="selectedGroupByValue" (onSelectTask)="onSelectTask($event)">
            </app-task-table>
        </p-tabPanel>
        <p-tabPanel header="Shared with Me">
            <app-task-table *ngIf="app.filterMode=='share-with-me'" [filterValue]="'SharedWithMe'" [searchValue]="searchValue" [filterInColumns]="filterInColumns" [cols]="cols" [isHideSide]="isHideSide" [selectedGroupByValue]="selectedGroupByValue" (onSelectTask)="onSelectTask($event)">
            </app-task-table>
        </p-tabPanel>
        <p-tabPanel header="Completed">
            <app-task-table *ngIf="app.filterMode=='completed'" [filterValue]="'completed'" [searchValue]="searchValue" [filterInColumns]="filterInColumns" [cols]="cols" [isHideSide]="isHideSide" [selectedGroupByValue]="selectedGroupByValue" (onSelectTask)="onSelectTask($event)">
            </app-task-table>
        </p-tabPanel>
        <p-tabPanel [disabled]="true" headerStyleClass="iconPanel">
            <ng-template pTemplate="header">
                <app-filters [listCols]="listColsAll"
                                [selectedParentModule]="{name:'Task',objectId:21,channelId:categorychannelId}"
                                [saveFilterData]="saveFilterData"
                                (applyFiltersColumns)="applyFilters($event)" [isTaskModule]="true" [selectedFilterValue]="selectedFilterValue"></app-filters>
                <span class="group-by-wrapper">
                    <span class="btnBars" (click)="groupby.toggle($event);" pTooltip="Group by"
                    tooltipPosition="top">
                        <i class="pi pi-tags"></i>
                    </span>
                    <span *ngIf="selectedGroupByValue" class="group-by-badge"></span>
                </span>
                <ng-container *ngIf="!showSideBarIcon">
                    <span class="btnBars p-mr-0" (click)="onToggleSideBar()" pTooltip="Hide side bar"
                    tooltipPosition="top" *ngIf="!isHideSide">
                        <i class="pi pi-arrow-left"></i>
                    </span>
                    <span class="btnBars p-mr-0" (click)="onToggleSideBar()" pTooltip="Show side bar"
                    tooltipPosition="top" *ngIf="isHideSide">
                        <i class="pi pi-arrow-right"></i>
                    </span>
                </ng-container>
                
                
                <span class="btnBars" (click)="refreshList()" pTooltip="Refresh" tooltipPosition="top">
                    <i class="pi pi-replay" ></i>
                </span>
                <span class="btnBars" (click)="openExport()" pTooltip="Export" tooltipPosition="top">
                    <i class="pi pi-upload"></i>
                </span>
                <span class="btnBars" (click)="openSetting()" pTooltip="Setting" tooltipPosition="top">
                    <i class="pi pi-cog"></i>
                </span>
                <span class="btnBars" (click)="showAddTask()" pTooltip="Create Task" tooltipPosition="top">
                    <i class="pi pi-plus"></i>
                </span>
            </ng-template>
        </p-tabPanel>
    </p-tabView>
</ng-container>

<p-overlayPanel #groupby [showCloseIcon]="true" [style]="{width: '300px'}">
    <ng-template pTemplate>
        <label>Group By</label>
        <p-dropdown [options]="enabledListCols" class="panelDD" [filter]="true"
            [(ngModel)]="selectedGroupBy" optionLabel="name" placeholder="Select Field">
        </p-dropdown>
        <div class="p-text-right p-mt-2">
            <p-button label="Reset" class="p-button-secondary p-mt-2 p-mr-2"
                (click)="resetGroup(true);groupby.hide()" [disabled]="!selectedGroupBy"></p-button>
            <p-button label="Apply" class="p-mt-2" (onClick)="applyGroup();groupby.hide()"
                [disabled]="!selectedGroupBy"></p-button>
        </div>
    </ng-template>
</p-overlayPanel>


<p-toast position="top-right" [baseZIndex]="10000"></p-toast>
<app-shared-create-task *ngIf="displayAddTask" [headerTitle]="'Add New Task'" [displayAddEditDialog]="displayAddTask"
    (cancelClicked)="cancelClicked($event)" (onCreateComplete)="reloadTaskiList()" [isAddTask]="isAddTask">
</app-shared-create-task>

<app-task-setting *ngIf="displaySetting" [disabledLabelNames]="disabledLabelNames" [display]="displaySetting" (cancelClicked)="cancelSetting()" (columnsettting)="columnsettting($event)" (savedColumnSettings)="savedColumnSettings()"></app-task-setting>

<app-task-workspace *ngIf="selectedView == 'list'" [isHideSide]="isHideSide" [selectedView]="selectedView"></app-task-workspace>
